import React from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import {Schedule} from '@material-ui/icons';
import {blue} from '@material-ui/core/colors';

function CnsProcedureProperties(props) {
  const {selectedCnsProcedure} = props;

  if (!!selectedCnsProcedure) {
    return (
      <Card>
        <CardHeader title={selectedCnsProcedure.name} subheader="Properties" />
        <Divider />
        <CardContent style={{overflow: 'auto', whiteSpace: 'nowrap'}}>
          <List>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <Schedule />
              </ListItemIcon>
              <ListItemText
                primary="Created Date"
                secondary={new Date(selectedCnsProcedure.createdDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
            <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
              <ListItemIcon>
                <Schedule />
              </ListItemIcon>
              <ListItemText
                primary="Last Modified Date"
                secondary={new Date(selectedCnsProcedure.modifiedDt).toLocaleDateString('en-AU')}
              />
            </ListItem>
          </List>
        </CardContent>
        <CardActions>
          <Button
            variant="outlined"
            href={`/#/Procedures/${selectedCnsProcedure.id}/import`}
            style={{color: blue[500]}}
          >
            Import
          </Button>
        </CardActions>
      </Card>
    );
  } else {
    return (
      <Card>
        <CardHeader title="Cns Procedure Properties" subheader="No Cns Procedure Selected" />
      </Card>
    );
  }
}

CnsProcedureProperties.propTypes = {
  selectedCnsProcedure: PropTypes.object,
};

CnsProcedureProperties.defaultProps = {
  selectedCnsProcedure: null,
};

export default CnsProcedureProperties;
